import { $ } from '../../../../../../base/browser/dom.js';
import { CellContentPart } from '../cellPart.js';
class CellDecorations extends CellContentPart {
    constructor(rootContainer, decorationContainer) {
        super();
        this.rootContainer = rootContainer;
        this.decorationContainer = decorationContainer;
    }
    didRenderCell(element) {
        const removedClassNames = [];
        this.rootContainer.classList.forEach(className => {
            if (/^nb\-.*$/.test(className)) {
                removedClassNames.push(className);
            }
        });
        removedClassNames.forEach(className => {
            this.rootContainer.classList.remove(className);
        });
        this.decorationContainer.innerText = '';
        const generateCellTopDecorations = () => {
            this.decorationContainer.innerText = '';
            element.getCellDecorations().filter(options => options.topClassName !== undefined).forEach(options => {
                this.decorationContainer.append($(`.${options.topClassName}`));
            });
        };
        this.cellDisposables.add(element.onCellDecorationsChanged((e) => {
            const modified = e.added.find(e => e.topClassName) || e.removed.find(e => e.topClassName);
            if (modified) {
                generateCellTopDecorations();
            }
        }));
        generateCellTopDecorations();
    }
}
export { CellDecorations };
